import Auth from '../../services/Auth';

const state = {
  loggedin: false,
  offlineMode: false,
  user: false,
  tokens: {
    access: null,
    accessExpiresIn: null,
  },
  url: false,
};

const getters = {
  user() {
    return state.user;
  },
  loggedin() {
    return state.loggedin;
  },
  accesstoken() {
    return state.tokens.access;
  },
  expiry() {
    return state.tokens.accessExpiresIn;
  },
  auth() {
    return state;
  },
  url() {
    return state.url;
  },
  offlineMode() {
    return state.offlineMode;
  }
};

const actions = {
  login({commit}, credentials) {
    commit('settings/setDomain', credentials.form.domain, {root: true});
    return Auth.login(credentials)
      .then(data => {
        commit('setAccessToken', data.access_token);
        commit('setAccessExpiresIn', data.expires_in);
        commit('setLoggedIn', true);
        commit('setOfflineMode', false);
        return this.dispatch('auth/authenticate');
      });
  },
  authenticate({commit}) {
    return Auth.authenticate()
      .then(data => {
        commit('setLoggedIn', true);
        commit('setUser', data);
      });
  },
  logout({commit}) {
    commit('setLoggedIn', false);
    commit('setUser', false);
    commit('clearAccessToken', false);
    commit('authenticators/clearState', null, {root: true});
    commit('secretTemplates/clearState', false, {root: true});
    commit('settings/clearState', false, {root: true});
    // commit('clearRefreshToken', false);
  },
  setOfflineMode({commit}, status) {
    commit('setOfflineMode',status);
  }

};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setAccessExpiresIn(state, expire) {
    let now = Math.floor(Date.now() / 1000);
    now += expire;
    state.tokens.accessExpiresIn = now;
  },
  setOfflineMode(state, status) {
    state.offlineMode = status;
    if (status) {
      state.tokens = {
        access: null,
        accessExpiresIn: null,
      };
    }
  },
  clearUser(state, user) {
    state.user = false;
  },
  setAccessToken(state, token) {
    localStorage.setItem('accessToken', token);
    state.tokens.access = token;
  },
  clearAccessToken(state) {
    localStorage.removeItem('accessToken');
    state.tokens.access = false;
  },
  setUrl(state, url) {
    state.url = url;
  },
  clearUrl(state) {
    localStorage.removeItem('url');
    state.url = false;
  },
  // setRefreshToken(state, token) {
  //   localStorage.setItem('refreshToken', token);
  //   state.tokens.refresh = token;
  // },
  // clearRefreshToken(state) {
  //   localStorage.removeItem('refreshToken');
  //   state.tokens.refresh = false;
  // },
  setLoggedIn(state, status) {
    state.loggedin = status;
  },
  loadOffline(state, store) {
    state.showOtp = store.showOtp;
    state.loggedin = store.loggedin;
    state.user = store.user;
    state.tokens = store.tokens;
    state.url = store.url;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js